export const RemoveCharsAccents = (e: any): any => {
  let target = e.target;

  target.value = target.value.toUpperCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  target.value = target.value.replace(/[^A-Z0-9 \n]/gi, "");

  return target;
};